"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Text_1 = require("./Text");
const typography_1 = require("../styles/typography");
const colors_1 = require("../styles/colors");
const react_textarea_autosize_1 = require("react-textarea-autosize");
const TextAreaInput = ({ id, size, rows, cols, isEditingText, label, placeholder, position, startEditingText, stopEditingText, text, updateText, }) => {
    let style = Object.assign({}, typography_1.text, typography_1.regular, { color: colors_1.charcoal, lineHeight: '24px', outline: 'none', width: '100%', display: 'block', border: '0px', resize: 'none', boxSizing: 'border-box', primaryTextSize: 'large' });
    switch (size) {
        case 'h1':
            style = Object.assign({}, style, typography_1.semibold, { lineHeight: '40px', fontSize: 32 });
            break;
        case 'h2':
            style = Object.assign({}, style, typography_1.semibold, { lineHeight: '32px', fontSize: 25 });
            break;
        case 'x-large':
            style = Object.assign({}, style, typography_1.light, { color: colors_1.graphite, lineHeight: '80px', fontSize: 64 });
            break;
        case 'large':
            style = Object.assign({}, style, { fontSize: 19 });
            break;
        case 'medium':
            style = Object.assign({}, style, { fontSize: 17 });
            break;
        case 'small':
            style = Object.assign({}, style, { fontSize: 15 });
            break;
    }
    if (position === 'center') {
        style = Object.assign({}, style, { textAlign: 'center' });
    }
    if (label) {
        style = Object.assign({}, style, { color: colors_1.graphite });
    }
    style = Object.assign({}, style);
    const renderTextArea = () => (React.createElement("div", null,
        React.createElement("style", { type: "text/css" }, `
                    .TextAreaInput::placeholder {
                        color: ${colors_1.silver};
                        cursor: default;
                        font-family: "Source Sans Pro", sans-serif;
                        font-size: 19px;
                        line-height: 24px;
                    }
                `),
        React.createElement(react_textarea_autosize_1.default, { className: "TextAreaInput", onBlur: stopEditingText, id: id, cols: cols, rows: rows, style: style, onChange: e => updateText(e.currentTarget.value), placeholder: placeholder, value: text, autoFocus: isEditingText })));
    if (placeholder) {
        if (!label)
            React.createElement("div", { onClick: startEditingText, style: { flex: '1 1 auto' } }, renderTextArea());
        return (React.createElement("div", { onClick: startEditingText, style: { flex: '1 1 auto' } },
            React.createElement(Text_1.default, { text: label, label: true, size: "small", textStyle: {
                    display: 'block',
                    color: colors_1.steel,
                } }),
            renderTextArea()));
    }
    if (!text && !isEditingText)
        React.createElement("div", { onClick: () => startEditingText(), style: { flex: '1 1 auto' } },
            React.createElement(Text_1.default, { text: label, label: true, size: "large", textStyle: {
                    display: 'block',
                    color: colors_1.steel,
                } }));
    return (React.createElement("div", { onClick: startEditingText, style: { flex: '1 1 auto' } },
        React.createElement(Text_1.default, { text: label, label: true, size: "small", textStyle: {
                display: 'block',
                color: colors_1.steel,
            } }),
        renderTextArea()));
};
TextAreaInput.defaultProps = {
    text: '',
    size: 'medium',
    position: 'left',
    placeholder: '',
};
exports.default = TextAreaInput;
